require.register("log/app", function(exports, require, module){
  $0
  
});

